import { formatInr } from "./quotationPdfTotals";
import { currencySymbol } from "./currency";

function nStr(q, key) {
  const v = q[key];
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function fmtAmt(n) {
  if (n == null || !Number.isFinite(Number(n))) return "—";
  return formatInr(n);
}

/**
 * Fixed ACE quotation table rows for @react-pdf/renderer (description + amount column).
 * @returns {Array<{ desc: string; amount: string | null; indent: boolean; section?: boolean; bold?: boolean }>}
 */
export function buildAceQuotationPdfRows(q) {
  const rows = [];
  const dist = q.distanceKm != null && q.distanceKm !== "" ? String(q.distanceKm) : "—";
  const load = (q.loadDescription || "").trim();
  const transportationLabel =
    load.length > 0
      ? `Transportation Charges (${dist} Kms) ${load}`
      : `Transportation Charges (${dist} Kms)`;
  rows.push({
    desc: transportationLabel,
    amount: fmtAmt(nStr(q, "transportationChargesAmount")),
    indent: false,
  });

  rows.push({
    desc: `Car Transportation charges(${dist} Kms)`,
    amount: fmtAmt(nStr(q, "carTransportationChargesAmount")),
    indent: false,
  });

  const cft =
    q.totalCft != null && q.totalCft !== ""
      ? String(q.totalCft)
      : "—";
  rows.push({
    desc: `Packing Charges (${cft} CFT)`,
    amount: null,
    indent: false,
    section: true,
  });

  rows.push({
    desc: "(i) Loading Charges",
    amount: fmtAmt(nStr(q, "loadingChargesAmount")),
    indent: true,
  });
  rows.push({
    desc: "(ii) Unloading Charges",
    amount: fmtAmt(nStr(q, "unloadingChargesAmount")),
    indent: true,
  });
  rows.push({
    desc: "(iii) Unpacking, Rearranging charges",
    amount: fmtAmt(nStr(q, "unpackingRearrangingChargesAmount")),
    indent: true,
  });
  rows.push({
    desc: "(iv) Shuttle Service / Long Carry Charges/Escort charges",
    amount: fmtAmt(nStr(q, "shuttleLongCarryEscortChargesAmount")),
    indent: true,
  });
  rows.push({
    desc: "(v) Shuttle Service charges will be as applicable",
    amount: null,
    indent: true,
    info: true,
  });

  const pct =
    q.carrierRiskPercent != null && q.carrierRiskPercent !== ""
      ? String(q.carrierRiskPercent)
      : "2";
  rows.push({
    desc: `Carrier's risk charges @ ${pct} % on value of Luggage`,
    amount: fmtAmt(nStr(q, "carrierRiskChargesAmount")),
    indent: false,
  });

  const decl = nStr(q, "declaredLuggageValue");
  rows.push({
    desc: decl != null ? `${currencySymbol()} ${formatInr(decl)}` : `${currencySymbol()} —`,
    amount: null,
    indent: true,
    info: true,
  });
  rows.push({
    desc: "Pot Value excluded",
    amount: null,
    indent: true,
    info: true,
  });
  rows.push({
    desc: "Tablet /Laptop Value excluded",
    amount: null,
    indent: true,
    info: true,
  });

  const finSub = nStr(q, "subTotal");
  const finGst = nStr(q, "gstAmount");
  const finTot = nStr(q, "totalAmount");

  rows.push({
    desc: "Sub Total",
    amount: finSub != null ? fmtAmt(finSub) : "—",
    indent: false,
    bold: true,
  });
  rows.push({
    desc: "GST as applicable",
    amount: finGst != null ? fmtAmt(finGst) : "—",
    indent: false,
  });
  rows.push({
    desc: "Total",
    amount: finTot != null ? fmtAmt(finTot) : "—",
    indent: false,
    bold: true,
  });

  rows.push({
    desc: "EXTRA HANDLING AND STORAGE",
    amount: null,
    indent: false,
    section: true,
  });
  const extra = (q.extraHandlingAndStorageNote || "").trim();
  if (extra) {
    rows.push({ desc: extra, amount: null, indent: true, info: true });
  }

  rows.push({
    desc: "e) Society / Local union/Octroi charges as actual extra.",
    amount: null,
    indent: false,
    info: true,
  });
  const oct = (q.localUnionOctroiNote || "").trim();
  if (oct) {
    rows.push({ desc: oct, amount: null, indent: true, info: true });
  }

  const hm = (q.handymanServicesNote || "").trim();
  rows.push({
    desc: `f) Handyman Services EXTRA${hm ? ` (${hm})` : ""}`,
    amount: null,
    indent: false,
    info: true,
  });

  const n1 = (q.quotationExtraNote1 || "").trim();
  if (n1) rows.push({ desc: n1, amount: null, indent: false, info: true });
  const n2 = (q.quotationExtraNote2 || "").trim();
  if (n2) rows.push({ desc: n2, amount: null, indent: false, info: true });

  return rows;
}
